
export function dateFormat(date:Date | string) {
    const newDate = new Date(date).toLocaleDateString('en-NL')
    // const newDate = new Date(date).toLocaleDateString()
    return newDate
}

// export function duration(startDate, endDate) {
//     const timeTaken = new Date(endDate) - new Date(startDate)
//     let seconds = ("0" + Math.floor(timeTaken / 1000 % 60)).slice(-2).toString()
//     let minutes = ("0" + Math.floor(timeTaken / 60000 % 60)).slice(-2).toString()

//     if(!startDate || !endDate) return undefined

//     return minutes+":"+seconds
// };


//------------- OPEN METEO

export const formatDate = (date: Date): string => {
  return date.toISOString().split('T')[0]; // Formato YYYY-MM-DD
};

export const getDateRangeForApi = (targetDate: Date, daysBack: number = 7): { start_date: string; end_date: string } => {
  const endDate = new Date(targetDate);
  const startDate = new Date(targetDate);
  startDate.setDate(startDate.getDate() - daysBack + 1); // +1 para incluir el día de inicio
  
  return {
    start_date: formatDate(startDate),
    end_date: formatDate(endDate)
  };
};